module.exports = __webpack_public_path__ + "img/scientificDegrees.dc695489.svg";